import component from './segments.vue'

export default component
